module.exports = __webpack_public_path__ + "img/07.61ae17ff.svg";